import noiseChunk from '@/shaders/noise.glsl?raw'

/**
 * Prepend the shared simplex-noise chunk to a fragment shader so it can call
 * `snoise` and `fbm`. Keeps the noise implementation in exactly one place.
 *
 * @param {string} fragmentSource - The fragment shader body that uses noise.
 * @returns {string} The fragment shader with the noise chunk prepended.
 */
export function withNoise(fragmentSource: string): string {
  return `${noiseChunk}\n${fragmentSource}`
}
